import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from "@material-ui/styles";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import SelectionCriteria from "../../../../../JsonScreen/Screen/ScreenComponents/SelectionCriteria";

const useStyles = makeStyles(() => ({
    cardContentWrapper: {
        maxHeight: 300,
        overflowY: "auto",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    fieldset: {
        padding: 2,
        margin: '4px 2px 0',
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    filterItemWrapper: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        alignItems: 'center',
        paddingRight: 5,
        '&:hover': {
            '& $removeBtnWrapper': {
                visibility: "visible"
            }
        }
    },
    removeBtnWrapper: {
        visibility: "hidden",
        position: 'absolute',
        right: 0
    },
    inputRoot: {
        fontSize: '0.9rem',
        paddingRight: "23px !important",
        '&[class*="MuiInput-root"]': {
            padding: 1,
            '& input:first-child': {
                padding: '4px 0 !important',
            },
        },
    },
    clearIndicator: {
        display: 'none',
    },
    paper: {
        width: 150,
        '& > ul': {
            maxHeight: 200,
            overflow: 'auto',
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    textField: {
        display: 'block',
        position: 'inherit',
        width: '100%',
    },
    input: {
        display: 'flex',
        padding: '0px 0px 0px 0px',
    },
    chip: {
        margin: 3
    },
    valueContainer: {
        display: 'flex',
        overflow: 'auto',
        paddingLeft: '3px',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
    },
}));

const PredefinedFilter = (props) => {
    const {predefinedFilter, onChangeValue, listId} = props;
    const classes = useStyles();
    return (
        <Card className={classes.fieldset}>
            <legend style={{fontWeight: 'bold'}}>
                Predefined Filter
            </legend>
            <Divider style={{width: '100%'}}/>
            <div className={classes.cardContentWrapper}>
                <SelectionCriteria
                    asComponent={true}
                    globalValues={{
                        param: {
                            'fakeScreen': {
                                values: predefinedFilter
                            }
                        }
                    }}
                    withoutGroups={false}
                    setValue={(v) => onChangeValue(v)}
                    component={{
                        properties: {
                            listId,
                            path: 'values',
                            allColumns: true,
                            type: 'system'
                            //connector: connector
                        },
                        styles: [{
                            margin: 0,
                        }]
                    }}
                    screenName={'fakeScreen'}
                />
            </div>
        </Card>
    )
};
export default PredefinedFilter

PredefinedFilter.propTypes = {
    predefinedFilter: PropTypes.array,
    sourceColumns: PropTypes.array,
    onChangeValue: PropTypes.func,
    listId: PropTypes.string,
    connector: PropTypes.object,
};
PredefinedFilter.defaultProps = {
    predefinedFilter: [],
    sourceColumns: []
};